export const featureFlags = {
  isPaypalEnabled: false,
}
